import { Tenant } from "components/Login";
import { useContext } from "react";

import { useJiraTrackerDoc } from "./useJiraTrackerDoc";

export const useTracker = () => {
  const tenantId = useContext(Tenant);
  const { doc } = useJiraTrackerDoc(`o/${tenantId}/integrations`);

  return doc?.data.state === "installed" ? doc.data : undefined;
};
